/**
 * §7.17 Decision Log — append-only audit trail.
 *
 * No fabricated data: there is no real decision-log backend yet, so this
 * surface shows an honest empty state + the constitutional invariants the
 * real log will enforce. The CRDT-backed, signed, append-only store lands in
 * v0.4 (see designs/biomax-epi/pacc-roadmap.md).
 */

export function DecisionLog() {
  return (
    <div className="surface">
      <div className="surface__header">
        <span className="surface__sec">§7.17</span>
        <h1 className="surface__title">Decision Log · append-only audit trail</h1>
      </div>
      <div className="surface__sub">
        Append-only + cryptographically signed; every decision reproducible from its determinism
        receipt years later. EDU — NOT FOR OPERATIONAL DEPLOYMENT.
      </div>

      <div className="panel panel--accent">
        <div style={{ padding: 'var(--bm-space-4)', fontSize: 'var(--bm-text-sm)', color: 'var(--bm-text-muted)', lineHeight: 1.7 }}>
          <strong style={{ color: 'var(--bm-text)' }}>No decisions logged.</strong> This surface intentionally ships
          empty — it activates only when connected to a real append-only decision store. We do not display a
          mock incident here, because a fabricated audit trail on a governance surface is the one thing that
          must never be faked. The backing store (CRDT-backed, signed, immutable) is a v0.4 workstream.
        </div>
      </div>

      <div className="panel">
        <div className="panel__head">
          <span className="panel__title">Constitutional invariants</span>
          <span className="panel__meta">enforced by the real log when wired</span>
        </div>
        <table className="dtable">
          <tbody>
            <tr><td>Append-only</td><td>Entries are immutable post-write; any modification attempt is flagged.</td></tr>
            <tr><td>Citation provenance</td><td>Every recommendation carries a PMID or institutional-source citation. None withheld.</td></tr>
            <tr><td>Determinism receipt</td><td>Every recommendation records engine version · catalog hash · seed · elapsed ms. Same input → identical output.</td></tr>
            <tr><td>Human-in-the-loop</td><td>PaCC never makes binding decisions. Humans decide; PaCC records.</td></tr>
            <tr><td>No auto-publish</td><td>Comms packs require human sign-off before any external channel.</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
